import { render, staticRenderFns } from "./CarouselBanner.vue?vue&type=template&id=380b08fb&scoped=true"
import script from "./CarouselBanner.vue?vue&type=script&lang=ts"
export * from "./CarouselBanner.vue?vue&type=script&lang=ts"
import style0 from "./CarouselBanner.vue?vue&type=style&index=0&id=380b08fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b08fb",
  null
  
)

export default component.exports